<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisAQI',
  routeInfo: {
    label: '空气质量分析',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/index.vue